<template>
  <div class="container-fluid">
    <div class="m-2">
    	<div class="row d-flex justify-content-center">
    		<div class="col-12">
    			<div class="row">
    				<div class="col-12">
    					<div class="alert alert-primary">
    						<div class="h4 text-center">
                  <linkto :link="'/customers/search'"/>
                  Ügyfél módosítás
                </div>
    					</div>
    				</div>
    			</div>
    			<div class="row d-flex justify-content-center align-items-center">
    				<customerdata
    					:change="true"
    					:id="$route.params.id"
    				>
    				</customerdata>
    			</div>
    		</div>
    	</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import customerdata from './customer_data'
export default {
  name: 'customer',
  components: {
  	customerdata
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/customers/customer.vue